import { useEffect, useState } from 'react';
import { isNullOrEmpty, isObjectNull } from '../../../components/helpers/ObjectHelpers';
import PilotApiRepository from '../../../repositories/api/PilotApiRepository';
import PilotAssignmentIdbRepository from '../../../repositories/idb/PilotAssignmentIdbRepository';
import { convertPilotAssignmentApiDtoToIdb, isPilotAssignmentAssignedAndNotProcessed } from '../pilot-assignment/helpers/PilotAssignmentHelpers';
import PilotageDetailConfirmPilotage from './PilotageDetailConfirmPilotage';
import { Card } from '../../../components/layout/card/Card';
import { SelfAssignCard } from '../pilot-assignment/components/SelfAssignCard';
import { processPilotAssignment } from '../pilot-assignment/helpers/PilotAssignmentProcessHelpers';
import { useSetHeaderContent, useWarningNotification } from 'components/hooks/useAppStore';

export default function PilotageDetailsAssignment({ pilotageId, updatePilotagePilot, pilotagePilotsInformation }) {
    const [data, setData] = useState(null);
    const addWarningNotification = useWarningNotification();
    const updateHeaderContent = useSetHeaderContent();

    useEffect(() => {
        const getPilotagePilot = async () => {
            if(navigator.onLine) {
                const pilotAssignment = await fetchPilotageAsync(pilotageId);
                if (!isObjectNull(pilotAssignment)) {
                    const idb = await PilotAssignmentIdbRepository.getByPilotageIdAsync(pilotageId);

                    if (!isObjectNull(idb)) {
                        const processedPilotAssignment = processPilotAssignment(idb, pilotAssignment);
                        await PilotAssignmentIdbRepository.setAsync(processedPilotAssignment);
                        
                        setData({ pilotagePilot: processedPilotAssignment });
                    } else {
                        await PilotAssignmentIdbRepository.setAsync(pilotAssignment);
                        setData({ pilotagePilot: pilotAssignment });
                    }
                }
            } else {
                const result = await PilotAssignmentIdbRepository.getByPilotageIdAsync(pilotageId);
                setData(() => ({
                    pilotagePilot: result
                }));
            }

        };

        getPilotagePilot();
    }, [pilotageId, updatePilotagePilot]);

      async function fetchPilotageAsync(pilotageId) {
        return await PilotApiRepository.getPilotageByIdAsync(pilotageId)
            .then((response) => response.json())
            .then((result) => {
                updateHeaderContent(result.pilotage.pilotageShip.shipName, result.pilotage.pilotageNo.toString(), true, false, true);
                const converted = convertPilotAssignmentApiDtoToIdb(result);
                return converted;
            })
            .catch((error) => {
                console.error(error);
                addWarningNotification("Kunne ikke hente inn oppdraget fra serveren.");
            })
    }

    return (
        <>
            {
                data && !isNullOrEmpty(data.pilotagePilot.convertToAvailableWorkTimePeriod) &&
                <Card title="Arbeidstid">
                    <div>
                        <p className="reject-pilotage-modal-text">
                            {data.pilotagePilot.convertToAvailableWorkTimePeriod}
                        </p>
                    </div>
                </Card>
            }

            {
                data && isPilotAssignmentAssignedAndNotProcessed(data.pilotagePilot) &&
                <PilotageDetailConfirmPilotage
                    state={data.pilotagePilot}
                    handleAssignmentStatus={handleUpdatePilotAssignmentAsync}
                />
            }
            <SelfAssignCard
                pilotageId={pilotageId}
                handleAssignmentStatus={handleUpdatePilotAssignmentAsync}
                pilotagePilotsInformation={pilotagePilotsInformation} />
        </>
    );

    async function handleUpdatePilotAssignmentAsync(pilotStatus) {
        const response = await PilotApiRepository.getPilotageByIdAsync(data.pilotagePilot.pilotage.pilotageId);
        const dto = await response.json();
        const pilotagePilot = convertPilotAssignmentApiDtoToIdb(dto);

        updatePilotAssignmentColour(pilotStatus);
        updatePilotagePilot(pilotagePilot);
    }

    function updatePilotAssignmentColour(pilotStatus) {
        const index = data.pilotagePilot.pilotage.pilotagePilotsInformation.findIndex(pilot => pilot.pilotPersonId === data.pilotagePilot.pilotPersonId);
        data.pilotagePilot.pilotage.pilotagePilotsInformation[index].pilotagePilotStatus = pilotStatus;
    }
}
